import React, { useState } from 'react';
import { ReactComponent as DropDownIcon } from 'Assets/svg/dropdown-icon.svg';
import { EMPTY_FUNCTION } from 'Utils/constants';

const Accordion = props => {
  const {
    title,
    children,
    className,
    isAccordionOpen,
    setIsAccordionOpen = EMPTY_FUNCTION,
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  const showContent = isAccordionOpen !== undefined ? isAccordionOpen : isOpen;

  return (
    <div
      className={`accordion${showContent ? ' open' : ''}${
        className ? ` ${className}` : ''
      }`}
    >
      <div
        className="title"
        onClick={() => {
          setIsOpen(!showContent);
          setIsAccordionOpen(!showContent);
        }}
      >
        <span>{title}</span>
        <DropDownIcon />
      </div>
      <div className="content">{children}</div>
    </div>
  );
};

export default Accordion;
